import {UmpireComponent} from '../umpire-component';
import {UmpireComponentTypeEnum} from '../umpire-component-type-enum';
import {UmpireImageOrientation} from '../umpire-image-orientation';

export interface UmpireComponentOttExternalContent
  extends UmpireComponent<UmpireComponentTypeEnum.OTT_EXTERNAL_CONTENT> {
  title: string;
  url: string;
  image_orientation: UmpireImageOrientation;
}
